const node = (tag, className, text) => {
  const element = document.createElement(tag);
  element.className = className;
  if (text !== undefined) element.textContent = text;
  return element;
};
function mount(section) {
  if (section.dataset.c21ReviewsMounted) return;
  const source = section.querySelector('.c21-reviews-native');
  const track = section.querySelector('[data-c21-testimonial-track]');
  const messages = JSON.parse(section.querySelector('[data-c21-review-messages]').textContent);
  const build = () => {
    const reviews = [...source.querySelectorAll('.jdgm-carousel-item')].filter(item => item.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent.trim());
    if (!reviews.length) return false;
    const score = review => Number.parseFloat(review.querySelector('.jdgm-carousel-item__review-rating')?.getAttribute('aria-label')) || 0;
    const detail = review => review.querySelector('.jdgm-carousel-item__review-body')?.textContent.trim().length || 0;
    reviews.sort((a, b) => score(b) - score(a) || detail(b) - detail(a));
    const seen = new Set();
    const cards = [];
    for (const review of reviews) {
      const id = review.dataset.reviewId;
      if (id && seen.has(id)) continue;
      if (id) seen.add(id);
      const card = node('article', 'c21-testimonial-card');
      const title = review.querySelector('.jdgm-carousel-item__review-title')?.textContent.trim();
      if (title) card.append(node('h3', '', title));
      const body = review.querySelector('.jdgm-carousel-item__review-body')?.textContent.trim() || '';
      const quote = node('blockquote', '', body);
      card.append(quote);
      if (body.length > 260) {
        quote.classList.add('c21-review-clamped');
        const more = node('button', 'c21-review-more', messages.readMore);
        more.type = 'button';
        more.setAttribute('aria-expanded', 'false');
        more.addEventListener('click', () => {
          const expanded = more.getAttribute('aria-expanded') !== 'true';
          more.setAttribute('aria-expanded', String(expanded));
          quote.classList.toggle('c21-review-clamped', !expanded);
          more.textContent = expanded ? messages.readLess : messages.readMore;
        });
        card.append(more);
      }
      const footer = node('div', 'c21-testimonial-author');
      const ratingSource = review.querySelector('.jdgm-carousel-item__review-rating');
      const rating = Number.parseFloat(ratingSource?.getAttribute('aria-label'));
      if (rating >= 0 && rating <= 5) {
        const stars = node('span', 'c21-review-stars', '★'.repeat(Math.round(rating)) + '☆'.repeat(5 - Math.round(rating)));
        stars.setAttribute('aria-hidden', 'true');
        footer.append(stars, node('span', 'c21-review-score', messages.rating.replace('[rating]', String(rating))));
      }
      footer.append(node('strong', '', review.querySelector('.jdgm-carousel-item__reviewer-name').textContent.trim()));
      card.append(footer);
      const imageSource = review.querySelector('.jdgm-carousel-item__product-image');
      if (imageSource?.alt) {
        const product = node('div', 'c21-testimonial-product');
        const image = node('img', '');
        image.src = imageSource.currentSrc || imageSource.getAttribute('data-src') || imageSource.src;
        image.alt = '';
        image.width = 44;
        image.height = 58;
        image.loading = 'lazy';
        product.append(image, node('span', '', imageSource.alt));
        product.setAttribute('aria-label', `${messages.product}: ${imageSource.alt}`);
        card.append(product);
      }
      cards.push(card);
    }
    track.replaceChildren(...cards);
    section.querySelector('.c21-testimonial-display').hidden = false;
    section.classList.add('c21-testimonials--ready');
    return true;
  };
  if (!build()) {
    const observer = new MutationObserver(() => { if (build()) observer.disconnect(); });
    observer.observe(source, { childList: true, subtree: true });
  }
  section.querySelectorAll('[data-c21-review-direction]').forEach(button => button.addEventListener('click', () => {
    const width = track.firstElementChild?.getBoundingClientRect().width || track.clientWidth;
    track.scrollBy({ left: Number(button.dataset.c21ReviewDirection) * (width + 18), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }));
  section.dataset.c21ReviewsMounted = 'true';
}
document.querySelectorAll('[data-c21-testimonials]').forEach(mount);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-c21-testimonials]').forEach(mount));
